module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "p-login container"
  }, [_c('el-row', {
    staticClass: "login-wrap"
  }, [_c('el-row', {
    staticClass: "login-con"
  }, [_c('el-row', {
    staticClass: "login-logo"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo-fw.svg"),
      "alt": "",
      "width": "72px"
    }
  })]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "login-form",
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('common.usernamePlaceholder')
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.$set(_vm.form, "username", $$v)
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('common.passwordPlaceholder')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      }
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('common.login')) + "\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "large",
      "type": "text"
    },
    on: {
      "click": _vm.loginByWeixin
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('pages.login.WeixinLogin')) + "\n          ")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "large",
      "type": "text"
    },
    on: {
      "click": _vm.redirectForgotPassword
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('pages.login.ForgotPassword')) + "\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f32c213"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 386
// module chunks = 1